import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center overflow-hidden stars-bg" style={{
    background: 'linear-gradient(180deg, #0B1026 0%, #0D1330 100%)'
  }} data-id="element-64">
      {/* Decorative sparkles */}
      <div className="absolute top-20 left-[10%] w-1 h-1 bg-white rounded-full animate-twinkle" data-id="element-65" />
      <div className="absolute top-40 right-[20%] w-1.5 h-1.5 bg-white rounded-full animate-twinkle" style={{
      animationDelay: '1s'
    }} data-id="element-66" />
      <div className="absolute bottom-32 left-[30%] w-1 h-1 bg-white rounded-full animate-twinkle" style={{
      animationDelay: '2s'
    }} data-id="element-67" />
      <div className="absolute top-60 right-[40%] w-1 h-1 bg-[#4ECDC4] rounded-full animate-twinkle" style={{
      animationDelay: '0.5s'
    }} data-id="element-68" />
      <div className="absolute bottom-48 right-[15%] w-1 h-1 bg-[#D4A853] rounded-full animate-twinkle" style={{
      animationDelay: '1.5s'
    }} data-id="element-69" />

      <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 py-16 md:py-24" data-id="element-70">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-71">
          {/* Text */}
          <motion.div initial={{
          opacity: 0,
          x: -40
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="order-2 md:order-1" data-id="element-72">
            <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight text-white mb-6" data-id="element-73">
              El Ritual Nocturno de Magnesio y Glicinato:{' '}
              <span className="text-[#D4A853]" data-id="element-74">
                El Fin de la Mente Acelerada
              </span>{' '}
              y el Cansancio Infinito
            </h1>

            <h2 className="text-lg md:text-xl text-[#4ECDC4] font-medium mb-8 leading-relaxed" data-id="element-75">
              Recupera tu sueño profundo y desactiva el estrés biológico en 10
              minutos, sin el aturdimiento de la melatonina.
            </h2>

            <p className="text-gray-300 text-base md:text-lg leading-relaxed mb-8" data-id="element-76">
              Son las 3:00 AM. Tu cuerpo se siente como si pesara una tonelada,
              pero tu mente está corriendo un maratón, repasando cada pendiente
              de mañana y cada error de ayer. No es falta de voluntad. No es
              "simplemente estrés". Es un sistema nervioso que ha olvidado cómo
              frenar porque le faltan las piezas bioquímicas para hacerlo.
            </p>

            <CTAButton subtitle="Compra segura. Acceso instantáneo tras el pago." data-id="element-77" />
          </motion.div>

          {/* Product Image */}
          <motion.div initial={{
          opacity: 0,
          x: 40
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3,
          ease: 'easeOut'
        }} className="order-1 md:order-2 flex justify-center" data-id="element-78">
            <div className="animate-float" data-id="element-79">
              <img src="https://cdn.magicpatterns.com/uploads/ux6ydQqkw9ff5Q9SZ1Ky5U/cambia_el_bote_202604281004.jpg" alt="Magnesium Glycinate 250mg - Vitalízate Ahora" className="w-72 sm:w-80 md:w-96 lg:w-[28rem] rounded-2xl shadow-2xl shadow-black/40" data-id="element-80" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}